const initialState = {
  product: null,
  loading: true,
  error: null,
};

const productDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "PRODUCT_DETAILS_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "PRODUCT_DETAILS_SUCCESS": {
      const product = action.payload;

      // ✅ Normalize pricing (VERY IMPORTANT)
      const finalPrice =
        product.isOnSale && product.discountPercent > 0
          ? product.price -
            (product.price * product.discountPercent) / 100
          : product.price;

      return {
        loading: false,
        product: {
          ...product,
          finalPrice,
        },
        error: null,
      };
    }

    case "PRODUCT_DETAILS_FAIL":
      return {
        loading: false,
        product: null,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default productDetailsReducer;